import { Icon } from "./Icon"
import { HireBenefits } from "./HireBenefits"
import { trackActivity } from "../activity"

const starPath = "m10 2 2.35 4.76 5.25.76-3.8 3.7.9 5.23L10 13.98l-4.7 2.47.9-5.23-3.8-3.7 5.25-.76Z"

function TrustStars() {
    return <span className="ah-trust-stars" aria-hidden="true">
        {[0, 1, 2, 3, 4].map(index => <svg key={index} className="ah-trust-star" viewBox="0 0 20 20">
            <rect className="ah-trust-star-background" width="20" height="20" rx="1" />
            <rect className="ah-trust-star-rating" width={index === 4 ? 10 : 20} height="20" rx="1" />
            <path className="ah-trust-star-base" d={starPath} />
            <path className="ah-trust-star-fill" d={starPath} style={index === 4 ? { clipPath: "inset(0 50% 0 0)" } : undefined} />
        </svg>)}
    </span>
}

export function CheckoutTrust() {
    return <section className="ah-panel ah-trust-card" aria-label="Customer reviews and hire benefits">
        <a className="ah-trust-link" href="https://uk.trustpilot.com/review/arctic-hire.co.uk" target="_blank" rel="noopener noreferrer" aria-label="Read Arctic Hire reviews on Trustpilot (opens in a new tab)" onClick={() => trackActivity("trustpilot_navigation")} onAuxClick={event => { if (event.button === 1) trackActivity("trustpilot_navigation") }}>
            <div className="ah-trust-heading">
                <div className="ah-trust-brand"><h3>Trustpilot</h3><TrustStars /></div>
                <p className="ah-trust-rating"><span><span className="ah-trust-rated-label">Rated </span><strong>4.3/5</strong></span><small>7 reviews</small></p>
            </div>
            <figure className="ah-trust-review">
                <blockquote>
                    <p>The whole experience was very impressive from booking and delivery to collection. Easily booked online and delivered promptly. Good communication during hire period as we required a time extension.</p>
                    <p>Collected on time. And the dehumidifier did an excellent job and was easy to use.</p>
                </blockquote>
                <figcaption>
                    <strong>G Ball</strong><span className="ah-trust-location">Sutton, UK</span>
                    <span className="ah-trust-verified"><Icon name="check-circle" />Verified Hire</span>
                </figcaption>
            </figure>
        </a>
        <HireBenefits className="ah-trust-benefits" />
    </section>
}
